import { useState } from "react";
import { extractLinks } from "@/lib/reels";
import { PrimaryButton, pasteFromClipboard } from "@/components/reels/controls";
import { BulkResults } from "@/components/reels/BulkResults";
import { useDownloadQueue } from "@/hooks/useDownloadQueue";

export const BulkCard = ({ quality }) => {
  const [text, setText] = useState("");
  const { items, busy, run, reset } = useDownloadQueue(quality);
  const links = extractLinks(text);
  const n = links.length;

  return (
    <>
      <div className="rs-material flex flex-col gap-3.5 p-4 rs-fade">
        <textarea
          data-testid="bulk-urls-input"
          className="rs-field min-h-[140px] resize-y py-1 text-[15px] leading-relaxed"
          placeholder={"Paste Instagram or TikTok links\none per line, or separated by spaces"}
          value={text}
          onChange={(e) => setText(e.target.value)}
          autoCapitalize="none" autoCorrect="off" spellCheck={false}
        />
        <div className="flex items-center justify-between">
          <span className="rs-secondary text-[13px]" data-testid="bulk-link-count">{n} valid link{n === 1 ? "" : "s"}</span>
          <div className="flex gap-2">
            <button className="rs-bordered" data-testid="bulk-clear-btn" disabled={busy || !text}
              onClick={() => { setText(""); reset(); }}>Clear</button>
            <button className="rs-bordered" data-testid="bulk-paste-btn" onClick={() => pasteFromClipboard(setText, true)}>Paste</button>
          </div>
        </div>
        <PrimaryButton testId="bulk-download-btn" busy={busy} disabled={busy || !n} onClick={() => run(links)}
          label={busy ? "Downloading…" : n ? `Download ${n} Reel${n === 1 ? "" : "s"}` : "Download Reels"} />
      </div>
      {items.length > 0 && <BulkResults items={items} busy={busy} />}
    </>
  );
};
